import { render, staticRenderFns } from "./policyHomePage.vue?vue&type=template&id=113be91c&scoped=true&"
import script from "./policyHomePage.vue?vue&type=script&lang=js&"
export * from "./policyHomePage.vue?vue&type=script&lang=js&"
import style0 from "./policyHomePage.vue?vue&type=style&index=0&id=113be91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113be91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113be91c')) {
      api.createRecord('113be91c', component.options)
    } else {
      api.reload('113be91c', component.options)
    }
    module.hot.accept("./policyHomePage.vue?vue&type=template&id=113be91c&scoped=true&", function () {
      api.rerender('113be91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/policyHomePage.vue"
export default component.exports